// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'root-router-view';
export const RootRouterView = withInstall(Index);

export default RootRouterView;
